import { ICard } from "../api/cards/types.ts";

export const getPaymentMethodName = (card: ICard | undefined): string => {
  if (!card || (card.paymentType !== "КАРТА" && card.paymentType !== "СБП")) {
    return "";
  }

  return card.paymentType === "КАРТА"
    ? `${card.cardType || "Платежная система неопределена"} *${card.lastFourDigits || ""}`
    : card.bankName || "Банк неопределен";
};

export const getMainPaymentMethod = (cards: ICard[] | undefined): ICard | undefined => {
  if (!Array.isArray(cards)) {
    return;
  }

  return cards.find(card => (
    card.isMainProduct
    && card.statusCode === "LINKED"
    && card.productId
    && (card.paymentType === "СБП" || card.paymentType === "КАРТА")
  ));
};
